import React from 'react';
import { Intl } from '@erecruit/core';
import { H1, Flex, H3, Button, FlexItem } from '@erecruit/ui-kit';

import getUserManager from '../../security/oidcUserManager';

const { FormattedMessage } = Intl;

export const UnappropriateRoleInfo = ({
  idToken,
}: {
  idToken: string | undefined;
}) => {
  const userManager = getUserManager();
  const onRedirectClick = async () => {
    await userManager.removeUser();
    // eslint-disable-next-line @typescript-eslint/camelcase
    userManager.signoutRedirect({ id_token_hint: idToken });
  };

  return (
    <Flex
      direction="column"
      padding={12}
      gutter={4}
      gutterDirection="vertical"
      align="center"
    >
      <FlexItem>
        <H1>
          <FormattedMessage id={messageIds.vms.login.unsupportedRole} />
        </H1>
      </FlexItem>
      <FlexItem>
        <H3 weight={400}>
          <FormattedMessage
            id={messageIds.vms.login.unsupportedRoleDescription}
          />
        </H3>
      </FlexItem>
      <FlexItem>
        <Button type="primary" onClick={onRedirectClick}>
          <FormattedMessage id={messageIds.vms.login.redirectToLogIn} />
        </Button>
      </FlexItem>
    </Flex>
  );
};
